/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';

// eslint-disable-next-line react/prop-types
const MultiValueLabel = (props) => (
    <>
        <components.MultiValueLabel {...props} />
    </>
);
const Option = (props) => {
    const { data } = props;
    return (
        <components.Option {...props}>
            <span className={cl('select__option__label')}>{data.label}</span>
        </components.Option>
    );
};

export default class FilterSelect extends Component {
    getOptions = () => {
        const { filter, options } = this.props;
        if (filter && filter.length > 0) {
            return options
                .filter((item) => filter.includes(item.value))
                .sort((a, b) => filter.indexOf(a.value) - filter.indexOf(b.value));
        }
        return options;
    };

    render() {
        const { placeholder, onChange, size } = this.props;
        return (
            <Select
                isMulti
                className={cl('select', `select--${size}`)}
                classNamePrefix="select"
                options={this.getOptions()}
                components={{ MultiValueLabel, Option }}
                placeholder={placeholder}
                onChange={onChange}
            />
        );
    }
}

FilterSelect.defaultProps = {
    filter: [],
    placeholder: '',
    onChange: null,
    size: 'normal',
    options: [],
};
FilterSelect.propTypes = {
    filter: PropTypes.array,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    size: PropTypes.oneOf(['big', 'normal', 'small', 'mini']),
};
